import React from "react";
import styles from './index.module.scss';
import disapproved from '@imgs/fileValidation/disapproved.png'
//导入antd
import { Modal, Button } from 'antd';

export const Disapproved = (props: any) => {
    const { errMsg } = props;

    //点击取消按钮的方法
    const handleCancel = () => {
        props.setDisapproved(false);
    };

    return (
    <div className={styles.disapproved}>
        <Modal
            className={styles.disapproved_modal}
            open={props.disapproved}
            onCancel={handleCancel}
            footer={null}
            closable={false}
            centered={true}
            width={405}
        >
            <div className={styles.disapproved_content}>
                <img src={disapproved} className={styles.disapproved_img} />
                <div className={styles.disapproved_text}>文件验真不通过！{errMsg}</div>
                <Button className={styles.disapproved_btn} onClick={handleCancel}>确定</Button>
            </div>
        </Modal>
    </div>)
}